module.exports = __webpack_public_path__ + "static/img/img1.9141f9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/20230828/img1.png
// module id = ZhAP
// module chunks = 1